import * as _ from 'lodash';
import { fromJS } from 'immutable';

import { fetchingState } from '@constants';

import * as actions from '../actions/evidence';

const initialState = fromJS({
  cadEvidences: { data: [], state: null },
  evidence: { data: {}, state: null },
  files: { data: [], state: null },
  file: { data: {}, state: null },
  plaintiffEvidences: { data: [], state: null },
});

const evidenceReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_CAD_EVIDENCES_START: {
      return state.setIn(['cadEvidences', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PLAINTIFF_EVIDENCES_START: {
      return state.setIn(
        ['plaintiffEvidences', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.FETCH_EVIDENCE_START: {
      return state.setIn(['evidence', 'state'], fetchingState.FETCHING);
    }
    case actions.INSERT_EVIDENCE_START: {
      return state.setIn(['evidence', 'state'], fetchingState.FETCHING);
    }
    case actions.UPDATE_EVDIENCE_TAGS_START:
    case actions.UPDATE_EVIDENCE_START: {
      return state.setIn(['evidence', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_EVIDENCE_START: {
      return state.setIn(['evidence', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_EVIDENCE_FILES_START: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_EVIDENCE_FILE_START: {
      return state.setIn(['file', 'state'], fetchingState.FETCHING);
    }
    case actions.INSERT_EVIDENCE_FILE_START: {
      return state.setIn(['file', 'state'], fetchingState.FETCHING);
    }
    case actions.UPDATE_EVIDENCE_FILE_START: {
      return state.setIn(['file', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_EVIDENCE_FILE_START: {
      return state.setIn(['file', 'state'], fetchingState.FETCHING);
    }

    case actions.FETCH_CAD_EVIDENCES_SUCCESS: {
      return state
        .setIn(['cadEvidences', 'state'], fetchingState.LOADED)
        .setIn(
          ['cadEvidences', 'data'],
          fromJS(
            _.get(action, 'data.results', []).filter(
              el => el.typeEvidence === 'cad',
            ),
          ),
        );
    }
    case actions.FETCH_PLAINTIFF_EVIDENCES_SUCCESS: {
      return state
        .setIn(['plaintiffEvidences', 'state'], fetchingState.LOADED)
        .setIn(
          ['plaintiffEvidences', 'data'],
          fromJS(
            _.get(action, 'data.results', []).filter(
              el => el.typeEvidence === 'plaintiff',
            ),
          ),
        );
    }
    case actions.FETCH_EVIDENCE_SUCCESS: {
      return state
        .setIn(['evidence', 'state'], fetchingState.LOADED)
        .setIn(
          ['evidence', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case actions.INSERT_EVIDENCE_SUCCESS: {
      return state
        .setIn(['evidence', 'state'], fetchingState.LOADED)
        .setIn(
          ['evidence', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case actions.UPDATE_EVIDENCE_SUCCESS: {
      return state
        .setIn(['evidence', 'state'], fetchingState.LOADED)
        .setIn(
          ['evidence', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case actions.UPDATE_EVDIENCE_TAGS_SUCCESS: {
      return state.setIn(
        ['evidence', 'data'],
        fromJS({
          ...state.getIn(['evidence', 'data']).toJS(),
          tags: _.get(action, 'data.results', []),
        }),
      );
    }
    case actions.DELETE_EVIDENCE_SUCCESS: {
      return state.setIn(['evidence', 'state'], fetchingState.LOADED);
    }
    case actions.FETCH_EVIDENCE_FILES_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.FETCH_EVIDENCE_FILE_SUCCESS: {
      return state
        .setIn(['file', 'state'], fetchingState.LOADED)
        .setIn(['file', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.INSERT_EVIDENCE_FILE_SUCCESS: {
      return state
        .setIn(['file', 'state'], fetchingState.LOADED)
        .setIn(['file', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.UPDATE_EVIDENCE_FILE_SUCCESS: {
      return state
        .setIn(['file', 'state'], fetchingState.LOADED)
        .setIn(['file', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.DELETE_EVIDENCE_FILE_SUCCESS: {
      return state.setIn(['file', 'state'], fetchingState.LOADED);
    }

    case actions.FETCH_CAD_EVIDENCES_ERROR: {
      return state.setIn(['cadEvidences', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_PLAINTIFF_EVIDENCES_ERROR: {
      return state.setIn(['plaintiffEvidences', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_EVIDENCE_ERROR: {
      return state.setIn(['evidence', 'state'], fetchingState.ERROR);
    }
    case actions.INSERT_EVIDENCE_ERROR: {
      return state.setIn(['evidence', 'state'], fetchingState.ERROR);
    }
    case actions.UPDATE_EVIDENCE_ERROR: {
      return state.setIn(['evidence', 'state'], fetchingState.ERROR);
    }
    case actions.DELETE_EVIDENCE_ERROR: {
      return state.setIn(['evidence', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_EVIDENCE_FILES_ERROR: {
      return state.setIn(['files', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_EVIDENCE_FILE_ERROR: {
      return state.setIn(['file', 'state'], fetchingState.ERROR);
    }
    case actions.INSERT_EVIDENCE_FILE_ERROR: {
      return state.setIn(['file', 'state'], fetchingState.ERROR);
    }
    case actions.UPDATE_EVIDENCE_FILE_ERROR: {
      return state.setIn(['file', 'state'], fetchingState.ERROR);
    }
    case actions.DELETE_EVIDENCE_FILE_ERROR: {
      return state.setIn(['file', 'state'], fetchingState.ERROR);
    }

    default: {
      return state;
    }
  }
};

export default evidenceReducer;
